export const CHECK_COPY = {
  paid: 'Paid — confirmed by Network.', cancelled: 'Cancelled at Network.',
  in_progress: 'Customer has started paying — not finished yet.',
  expired: 'Expired at Network — you can retire it.', retire_available: 'Expired at Network — you can retire it.',
  unknown: "Network didn't give a clear answer. Accounts has been told.",
};
export const REPLACEMENT_COPY = {
  reconcile_replacement: 'New link not confirmed by Network yet. Accounts must use the activation/reconciliation controls on the new intent.',
  reload_replacement: 'Replacement already recorded. Reloading its saved state — no second replacement.',
};
export function canRetireLink(intent, check, now = Date.now()) {
  if (!intent || !['active', 'cancellation_pending', 'expired'].includes(intent.status)) return false;
  const age = now - Date.parse(check?.completed_at);
  const fresh = check?.status === 'complete' && String(check.intent_id) === String(intent.id)
    && Number(check.intent_version) === Number(intent.version) && age >= 0 && age <= 300000;
  if (fresh && ['paid', 'in_progress'].includes(check.outcome)) return false;
  return Boolean(intent.cancellation_attempts?.some(attempt => attempt.status === 'rejected')
    || (fresh && ['expired', 'retire_available'].includes(check.outcome)));
}
export const watchingRetiredLink = retirement => !!retirement && (retirement.watch_until === null || Date.parse(retirement.watch_until) > Date.now());
// The query projection omits intent_id because the check is nested under its intent.
export function latestLinkCheck(intent, sessionCheck) {
  const saved = intent?.latest_provider_status_check;
  const local = sessionCheck && String(sessionCheck.intent_id) === String(intent?.id) ? sessionCheck : null;
  const latest = saved && (!local || Number(saved.id) >= Number(local.id || 0)) ? saved : local;
  return latest ? { ...latest, intent_id: intent.id } : null;
}
